import { Maybe } from 'aem-libs-ts/src/types/utility'

type Fn<Arg> = (...args: Arg[]) => unknown
type Params<Arg, Fcn extends Fn<Arg>> = Fcn extends undefined ? [] : Parameters<Fn<Arg>>

export function conditionalInvoke<Arg>(fcn: Maybe<Fn<Arg>>, args?: Params<Arg, Fn<Arg>>): void {
  if (fcn) {
    args && args?.length > 0 ? fcn(...args) : fcn()
  }
}

export function invokeIf<TValue>(
  predicate: boolean | (() => boolean),
  fcn: (...args: TValue[]) => void,
  args: Parameters<typeof fcn> = []
): void {
  const callPredicate = typeof predicate === 'function' ? predicate() : predicate

  if (callPredicate) {
    fcn(...args)
  }
}
